import React, { useState, useEffect, useRef } from "react";
import { useNavigate, useParams, useLocation } from "react-router-dom";
import InputField from "../../../Pages/InputField/InputField";
import { Row, Col } from "react-bootstrap";
import axios from "axios";
import baseURL from "../../../../Url/NodeBaseURL"; // Ensure this is correctly set

function SubCategory() {
  const navigate = useNavigate();
  const { state } = useLocation();
  const { subcategory_id, metal_type, orderDetails } = state || {}; // Destructure state to get subcategory_id and location
  console.log("orderDetails in subcat", orderDetails?.[0]?.category);

  const [formData, setFormData] = useState({
    category_id: "",
    metal_type_id: "",
    metal_type: orderDetails?.[0]?.metal_type || metal_type ||  "", // Initialize with passed metal_type if available
    category:  orderDetails?.[0]?.category || "",
    sub_category_name: "",
    pricing: "By Weight",
    pricingOpt:"",
    prefix: "",
    purity: "",
    mc_on: "",
    wastage_percent:"",
    selling_purity: "91.6%",
    printing_purity: "",
    custom_purity: "",
    selling_purity_disabled: false,
  });

  const [metalOptions, setMetalOptions] = useState([]);
  const [allCategoryOptions, setAllCategoryOptions] = useState([]);
  const [filteredCategoryOptions, setFilteredCategoryOptions] = useState([]);
  const [prefixError, setPrefixError] = useState("");
  const [existingPrefixes, setExistingPrefixes] = useState([]);

  // Modify the useEffect that fetches metal types to preserve the passed metal_type
  useEffect(() => {
    const fetchMetalTypes = async () => {
      try {
        const response = await axios.get(`${baseURL}/metaltype`);
        const metalTypes = response.data.map((item) => ({
          value: item.metal_name,
          label: item.metal_name,
          id: item.metal_type_id,
        }));

        console.log("Fetched Metal Types:", metalTypes);

        setMetalOptions(metalTypes);

        // If metal_type was passed in state, find and set its ID
        if (metal_type && !subcategory_id) {
          const selectedMetal = metalTypes.find(
            (option) => option.value.toLowerCase() === metal_type.toLowerCase()
          );

          if (selectedMetal) {
            setFormData((prev) => ({
              ...prev,
              metal_type: selectedMetal.value,
              metal_type_id: selectedMetal.id,
            }));
          }
        }
      } catch (error) {
        console.error("Error fetching metal types:", error);
      }
    };
    fetchMetalTypes();
  }, [metal_type, subcategory_id]);

  // Fetch categories
  useEffect(() => {
    const fetchCategories = async () => {
      try {
        const response = await axios.get(`${baseURL}/get/products`);
        const categories = response.data.map((item) => ({
          value: item.product_name,
          label: item.product_name,
          id: item.product_id,
          metal_type: item.Category,
        }));
        setAllCategoryOptions(categories);
      } catch (error) {
        console.error("Error fetching categories:", error);
      }
    };
    fetchCategories();
  }, []);

  // Fetch existing prefixes
  useEffect(() => {
    const fetchExistingPrefixes = async () => {
      try {
        const response = await axios.get(`${baseURL}/subcategory`);
        const prefixes = response.data.data.map((item) => item.prefix);
        setExistingPrefixes(prefixes);
        console.log("Fetched existing prefixes:", prefixes);
      } catch (error) {
        console.error("Error fetching existing prefixes:", error);
      }
    };
    fetchExistingPrefixes();
  }, []);

  // Function to generate prefix from category and sub category name
  const generatePrefix = (categoryName, subCategoryName) => {
  if (!categoryName || !subCategoryName) return "";

  const getInitials = (str) =>
    str
      .trim()
      .split(/\s+/)
      .map((word) => word.charAt(0).toUpperCase())
      .join("");

  const categoryPrefix = getInitials(categoryName);
  const subCategoryPrefix = getInitials(subCategoryName);

  return `${categoryPrefix}-${subCategoryPrefix}`;
};


  // Filter categories based on selected metal type
  useEffect(() => {
    const filteredCategories = allCategoryOptions.filter(
      (category) => category.metal_type === formData.metal_type
    );
    console.log("Filtered Categories:", filteredCategories);
    setFilteredCategoryOptions(filteredCategories);

    if (!subcategory_id && !formData.category) {
      setFormData((prevData) => ({
        ...prevData,
        category: "",
        category_id: "",
      }));
    }
  }, [formData.metal_type, allCategoryOptions, subcategory_id]);

  // Fetch subcategory data when subcategory_id is provided
  useEffect(() => {
    if (
      subcategory_id &&
      metalOptions.length > 0 &&
      allCategoryOptions.length > 0
    ) {
      const fetchSubcategoryData = async () => {
        try {
          const response = await axios.get(
            `${baseURL}/subcategory/${subcategory_id}`
          );
          const subcategoryData = response.data;

          console.log("Subcategory Data:", subcategoryData);
          setFormData((prevData) => ({
            ...prevData,
            ...subcategoryData,
            category: subcategoryData.category?.toUpperCase() || "",
            category_id: subcategoryData.category_id || "",
          }));
        } catch (error) {
          console.error("Error fetching subcategory:", error);
        }
      };
      fetchSubcategoryData();
    }
  }, [subcategory_id, metalOptions, allCategoryOptions]);
  const handleChange = (e) => {
    const { name, value } = e.target;

    let modifiedValue = value;
    if (name === "sub_category_name" || name === "prefix" || name === "printing_purity") {
      modifiedValue = value.toUpperCase();
    }

    if (name === "metal_type") {
      // Log the selected value to check
      console.log("Selected Metal Type:", modifiedValue);

      const selectedMetal = metalOptions.find(
        (option) => option.value.toLowerCase() === modifiedValue.toLowerCase()
      );

      // Log the selected metal to ensure it's found
      console.log("Selected Metal:", selectedMetal);

      setFormData((prevData) => ({
        ...prevData,
        metal_type: selectedMetal?.value || "",
        metal_type_id: selectedMetal?.id || "",
        category: "",
        category_id: "",
      }));
    } else if (name === "category") {
      const selectedCategory = filteredCategoryOptions.find(
        (option) => option.value === modifiedValue
      );
      setFormData((prevData) => ({
        ...prevData,
        category: selectedCategory?.value || "",
        category_id: selectedCategory?.id || "",
      }));
    } else if (name === "sub_category_name") {
      // Auto-generate prefix when sub category name changes (only in create mode)
      if (!subcategory_id) {
        const generatedPrefix = generatePrefix(formData.category, modifiedValue);
        console.log("Generated prefix:", generatedPrefix);
        console.log("Existing prefixes:", existingPrefixes);
        console.log(
          "Prefix exists:",
          existingPrefixes.includes(generatedPrefix)
        );

        setFormData((prevData) => ({
          ...prevData,
          [name]: modifiedValue,
          prefix: generatedPrefix,
        }));

        // Validate the generated prefix
        if (generatedPrefix && existingPrefixes.includes(generatedPrefix)) {
          setPrefixError("Prefix already exists");
        } else {
          setPrefixError("");
        }
      } else {
        setFormData((prevData) => ({
          ...prevData,
          [name]: modifiedValue,
        }));
      }
    } else if (name === "prefix") {
      // Validate prefix when manually changed
      console.log("Manual prefix change:", modifiedValue);
      console.log("Existing prefixes:", existingPrefixes);
      console.log("Prefix exists:", existingPrefixes.includes(modifiedValue));

      if (modifiedValue && existingPrefixes.includes(modifiedValue)) {
        setPrefixError("Prefix already exists");
      } else {
        setPrefixError("");
      }

      setFormData((prevData) => ({
        ...prevData,
        [name]: modifiedValue,
      }));
    } else if (name === "purity" || name === "mc_on") {
      setFormData((prevData) => {
        const purity =
          name === "purity"
            ? parseFloat(modifiedValue)
            : parseFloat(prevData.purity);
        const mc =
          name === "mc_on"
            ? parseFloat(modifiedValue)
            : parseFloat(prevData.mc_on);

        const updatedData = { ...prevData, [name]: modifiedValue };

        if (!isNaN(purity) && !isNaN(mc)) {
          updatedData.selling_purity = (purity + mc).toFixed(2) + "%";
          updatedData.selling_purity_disabled = true;
        } else {
          updatedData.selling_purity_disabled = false;
        }

        return updatedData;
      });
    } else {
      setFormData((prevData) => ({
        ...prevData,
        [name]: modifiedValue,
      }));
    }
  };

  // Submit form data
  // const handleSubmit = async (e) => {
  //   e.preventDefault();

  //   // Log formData before submitting to check its structure
  //   console.log("Form Data being submitted:", formData);
  //   console.log("metal_type_id:", formData.metal_type_id);

  //   try {
  //     if (subcategory_id) {
  //       await axios.put(`${baseURL}/subcategory/${subcategory_id}`, formData);
  //       alert("Subcategory updated successfully!");
  //     } else {
  //       await axios.post(`${baseURL}/subcategory`, formData);
  //       alert("Subcategory created successfully!");
  //     }
  //     // navigate("/subcategorytable");
  //     // const from = location.state?.from || "/subcategorytable";

  //     // navigate(-1);
  //     // navigate("/sales", { state: { newSubCategory: formData.sub_category_name } });
  //     const from = location.state?.from || "/subcategorytable";
  //     navigate(from, {
  //       state: { newSubCategory: formData.sub_category_name }
  //     });

  //   } catch (error) {
  //     console.error("Error saving subcategory:", error.message);
  //     alert("Failed to save subcategory. Please try again.");
  //   }
  // };
  const handleSubmit = async (e) => {
    e.preventDefault();

    // Check required fields based on pricing
    if (formData.pricing === "By Weight" && !formData.selling_purity) {
      alert("Selling Purity is required when pricing is By Weight");
      return;
    }

    // Check if prefix already exists
    if (prefixError) {
      alert("Please fix the prefix error before submitting");
      return;
    }

    // Log formData before submitting to check its structure
    console.log("Form Data being submitted:", formData);
    console.log("metal_type_id:", formData.metal_type_id);

    try {
      if (subcategory_id) {
        await axios.put(`${baseURL}/subcategory/${subcategory_id}`, formData);
        alert("Subcategory updated successfully!");
      } else {
        await axios.post(`${baseURL}/subcategory`, formData);
        alert("Subcategory created successfully!");
      }
      const from = location.state?.from || "/subcategorytable";
      navigate(from, {
        state: {
          fullSubCategoryData: formData,
          orderDetails: [
            {
              ...location.state?.orderDetails?.[0],
              category: formData.category,
              product_name: formData.sub_category_name,
              metal_type: formData.metal_type,
              pricing: formData.pricing,
            },
          ],
        },
      });
    } catch (error) {
      console.error("Error saving subcategory:", error.message);
      alert("Failed to save subcategory. Please try again.");
    }
  };
  const location = useLocation();
  const handleBack = () => {
    // navigate("/subcategorytable");
    // const from = location.state?.from || "/subcategorytable";
    navigate(-1);
  };

  return (
    <div className="main-container">
      <div className="customer-master-container">
        <h2>{subcategory_id ? "Edit Sub Category" : "Add Sub Category"}</h2>
        <form className="customer-master-form" onSubmit={handleSubmit}>
          <Row>
            <Col md={3}>
              <InputField
                label="Metal Type"
                name="metal_type"
                type="select"
                value={formData.metal_type}
                onChange={handleChange}
                options={metalOptions.map((option) => ({
                  value: option.value,
                  label: option.label,
                }))}
                required
                autoFocus
              />
            </Col>
            <Col md={3}>
              <InputField
                label="Category"
                name="category"
                type="select"
                value={formData.category}
                onChange={handleChange}
                options={filteredCategoryOptions.map((option) => ({
                  value: option.value,
                  label: option.label,
                }))}
                required
              />
            </Col>

            <Col md={3}>
              <InputField
                label="Sub Category"
                name="sub_category_name"
                value={formData.sub_category_name}
                onChange={handleChange}
                required
              />
            </Col>

            <Col md={3}>
              <InputField
                label="Pricing"
                name="pricing"
                type="select"
                value={formData.pricing} // No need for fallback value
                onChange={handleChange}
                options={[
                  { value: "By Weight", label: "By Weight" },
                  { value: "By fixed", label: "By fixed" },
                  ...(formData.pricing &&
                  !["By Weight", "By fixed"].includes(formData.pricing)
                    ? [{ value: formData.pricing, label: formData.pricing }]
                    : []),
                ]}
              />
            </Col>
            {formData.pricing=== "By Weight" && (
              <Col md={3}>
              <InputField
                label="Pricing By Weight"
                name="pricingOpt"
                type="select"
                value={formData.pricingOpt}
                onChange={handleChange}
                options={[
                  { value: "Gross Weight", label: "Gross Weight" },
                  { value: "Net Weight", label: "Net Weight" },
                ]}
              />
            </Col>
            )}
            <Col md={3}>
              <InputField
                label="Prefix"
                name="prefix"
                value={formData.prefix}
                onChange={handleChange}
                required
              />
              {prefixError && (
                <div
                  className="error-message"
                  style={{ color: "red", fontSize: "12px", marginTop: "5px" }}
                >
                  {prefixError}
                </div>
              )}
            </Col>

            <Col md={3}>
              <InputField
                label="Purchase Purity"
                name="purity"
                value={formData.purity}
                onChange={handleChange}
                required
              />
            </Col>
            <Col md={3}>
              <InputField
                label="+/- MC%"
                name="mc_on"
                value={formData.mc_on}
                onChange={handleChange}
              />
            </Col>
            <Col md={3}>
              <InputField
                label="+/- Wastage%"
                name="wastage_percent"
                value={formData.wastage_percent}
                onChange={handleChange}
              />
            </Col>
            <Col md={3}>
              <InputField
                label="Selling Purity"
                name="selling_purity"
                type="select"
                value={formData.selling_purity}
                onChange={handleChange}
                options={[
                  { value: "91.6%", label: "91.6%" },
                  { value: "99.9%", label: "99.9%" },
                  { value: "75%", label: "75%" },
                  { value: "Manual", label: "Manual" },
                  ...(formData.selling_purity_disabled
                    ? [
                        {
                          value: formData.selling_purity,
                          label: formData.selling_purity,
                        },
                      ]
                    : []),
                ]}
                disabled={formData.selling_purity_disabled}
                required={formData.pricing === "By Weight"} // Only required when pricing is "By Weight"
              />
            </Col>
            {formData.selling_purity === "Manual" && (
              <Col md={3}>
                <InputField
                  label="Custom Purity %"
                  name="custom_purity"
                  value={formData.custom_purity || ""}
                  onChange={handleChange}
                />
              </Col>
            )}

            <Col md={3}>
              <InputField
                label="Printing Purity"
                name="printing_purity"
                value={formData.printing_purity}
                onChange={handleChange}
                required
              />
            </Col>
          </Row>
          <div className="sup-button-container">
            <button type="button" className="cus-back-btn" onClick={handleBack}>
              Close
            </button>
            <button type="submit" className="cus-submit-btn">
              {subcategory_id ? "Update" : "Save"}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}

export default SubCategory;
